import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-ecatalogus',
  templateUrl: '../../../../assets/html/fabrikanten_ecatalogus.html',
  styleUrls: ['./ecatalogus.component.css']
})
export class EcatalogusComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    var t = $('[data-parallax="scroll"]').data('imageSrc');
    $('[data-parallax="scroll"]').parallax({imageSrc: t});
  }

}
